// AuthContext.tsx
import React, { useState, useEffect } from 'react';
import { type Traductions } from '../../types/Traductions';
import TradsContext from './TradsContext';
import CONFIG from '../../config';
import type { ServerReponse } from '../../types/CommonReponse';

//import {  useLookupTraductionsQuery } from '../../stores/OkOkStore';
const TradsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [tradsCache,setTradsCache]=useState<Record<string,string>>({});
    //const [params,setParams]=useState<Record<string, string>>({page:"0",maxperpage:"10000"});
    const [loaded,setLoaded]=useState(false);
    //const { data, isLoading,isSuccess }=useLookupTraductionsQuery(params);

    const [lang,setLang]=useState('fr');
    useEffect(function(){

        fetch(CONFIG.SERVER+'/traductions?maxperpage=10000')
        .then(response=>response.json())
        .then((data:ServerReponse<Traductions[]>)=> {
            data.data.forEach((v:Traductions) => {
                tradsCache[v.name]=v.value;
            });
            setTradsCache(tradsCache);
            setLoaded(true);
        }).catch(()=>{
            console.log("erreur");
        });
    },[loaded,tradsCache]);
    const translate =  (text:string|undefined): string => {
        if(!text){
            return '';
        }
        if(tradsCache[text]){
            return tradsCache[text];
        }else {
            return text;
        }
    }
  return (
    <TradsContext value={{translate,lang,setLang,tradsCache,loaded,setLoaded  }}>
      {children}
    </TradsContext>
  );

}
export default TradsProvider;